/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { BagCartDataFragmentDoc } from './BagCart.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddLineItemToCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: string | null | undefined;
  readonly deliveryOrderDetails?: DeliveryOrderDetailInput | null | undefined;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: string | number;
  readonly quantity: number;
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly restaurantId?: number | null | undefined;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: string | null | undefined;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type DeliveryOrderDetailInput = {
  readonly addressId: string | number;
  readonly deliveryFee: number;
  readonly tip: number;
  readonly vendor: string;
  readonly vendorRestaurantId: string;
};

export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type IngredientModificationInput = {
  readonly ingredientId: string | number;
};

export type IngredientSubstitutionModificationInput = {
  readonly addedIngredientId: string | number;
  readonly removedIngredientId: string | number;
};

export type MixedDressingDetailsInput = {
  readonly ingredientId: string | number;
  readonly weight: DressingWeight;
};

export type ModifierType = 'ADDITION' | 'INCLUDED' | 'MIXED_DRESSING' | 'REMOVAL' | 'SUBSTITUTION';

export type OrderState =
  | 'Active'
  | 'Canceled'
  | 'Complete'
  | 'Discarded'
  | 'LockedChangeLocation'
  | 'LockedCheckout';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type AddUpsellToBagMutationVariables = Exact<{
  input: Types.AddLineItemToCartInput;
}>;

export type AddUpsellToBagMutation = {
  readonly addLineItemToCart:
    | {
        readonly __typename: 'AddLineItemToCartSuccess';
        readonly cart: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: {
            readonly canApplyRewards: boolean;
            readonly canSubmitOrder: boolean;
            readonly canUpdateOrderDetails: boolean;
          };
          readonly multipartyDetails: {
            readonly joinCode: string;
            readonly displayName: string;
          } | null;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly entityId: number | null;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showOutpostPriceDifferenciationDisclosure: boolean;
            readonly showDeliveryPriceDifferenciationDisclosure: boolean;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly canEdit: boolean;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly isModifiable: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
            readonly orderParticipant: {
              readonly id: string;
              readonly displayName: string | null;
              readonly isMe: boolean;
            } | null;
          }>;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
        };
      }
    | { readonly __typename: 'InvalidAddress' }
    | { readonly __typename: 'LineItemModificationsInvalidException' }
    | { readonly __typename: 'LocationClosed' }
    | { readonly __typename: 'LoyaltyScanTokenExpired' }
    | { readonly __typename: 'MaxEntreeReached' }
    | {
        readonly __typename: 'MaxModificationsExceeded';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'OrderLocked' }
    | {
        readonly __typename: 'ProductOutOfStock';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'ProductUnavailable' }
    | { readonly __typename: 'RestaurantHoursMissing' }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const AddUpsellToBagDocument = gql`
  mutation AddUpsellToBag($input: AddLineItemToCartInput!) {
    addLineItemToCart(input: $input) {
      __typename
      ... on AddLineItemToCartSuccess {
        cart {
          ...BagCartData
        }
      }
      ... on RestaurantMaxQuantityExceeded {
        message
        status
      }
      ... on RestaurantMaxDeliveryQuantityExceeded {
        message
        status
      }
      ... on ProductOutOfStock {
        message
        status
      }
      ... on MaxModificationsExceeded {
        message
        status
      }
      ... on ValidationError {
        message
        status
        fieldErrors {
          field
          message
        }
      }
    }
  }
  ${BagCartDataFragmentDoc}
`;

export function useAddUpsellToBagMutation() {
  return Urql.useMutation<AddUpsellToBagMutation, AddUpsellToBagMutationVariables>(
    AddUpsellToBagDocument,
  );
}
